import PatientVitals from './PatientVitals';

export default PatientVitals;
